import { IError } from '../base/error'
import ServiceBase from '../base/service.base'

import { ICertificate } from './certificate.types'

export class Certificate extends ServiceBase {
  public async getCompanyCertificates(taxId: string): Promise<ICertificate[]> {
    const url = `/certificate/company/${encodeURIComponent(taxId)}`

    const response = await this.request.get<ICertificate[], IError>(url)

    if (response.result) {
      return response.result
    } else {
      const error = response.error as IError
      throw new IError(error.statusCode, error.message, error.error)
    }
  }

  public async getTypes(): Promise<string[]> {
    const url = '/certificate/types'

    const response = await this.request.get<{ types: string[] }, IError>(url)

    if (response.result) {
      return response.result.types
    } else {
      const error = response.error as IError
      throw new IError(error.statusCode, error.message, error.error)
    }
  }
}
